import { DateFilterState } from './store/date.types';

export const dateFilterHash = (selectedDate: DateFilterState['selectedDate']): string => String(selectedDate);
